// extracted by mini-css-extract-plugin
export default {"contentCard":"contentCard_contentCard__nNKC1","contentCard__title":"contentCard_contentCard__title__cPwfr"};